import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';

import {STAR_FILTER} from '../shared/defines/protocol';
import {APP_VERSION, SEUNGJO_DISP_TYPE} from '../shared/defines/client.const';
import {MENU_PAGE} from '../shared/defines/desktop.const';
import {OPTION_ITEM, OptionService} from '../shared/services/option/option.service';
import {GlobalEventService} from "../shared/services/global-event/global-event.service";
import {SnsInfo, SnsService} from "../shared/services/sns/sns.service";


@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss']
})
export class OptionsComponent implements OnInit, OnDestroy {
  @ViewChild('main', {static: true}) main?: ElementRef; // ngOnInit() 에서 사용 가능

  protected readonly APP_VERSION = APP_VERSION;
  protected readonly MENU_PAGE = MENU_PAGE;

  protected get optionItems(): Array<OPTION_ITEM> {
    return this.option.optionItems;
  }

  protected snsInfo?: SnsInfo;

  constructor(
    private option: OptionService,
    private globalEventSvc: GlobalEventService,
    private snsSvc: SnsService,
  ) {
    // super(globalEventSvc);

    this.snsSvc.GetSnsInfo().subscribe((snsInfo: SnsInfo) => {
      this.snsInfo = snsInfo;
      // console.warn('OptionsComponent::constructor() snsInfo', this.snsInfo);
    });
  }

  ngOnInit(): void {
    // if (this.main) {
    //   this.InitFocusMain(this.main);
    // }
    // else {
    //   console.error('OptionComponent::ngOnInit() main is null');
    // }
  }

  ngOnDestroy() {
    // this.ExitFocusMain();
  }


  public get autoPlay(): boolean {
    return this.option.autoPlay;
  }

  public set autoPlay(value: boolean) {
    this.option.autoPlay = value;
  }

  public setAutoPlay(value: boolean): void {
    this.autoPlay = value;
  }

  public get largeMode(): boolean {
    return this.option.largeMode;
  }

  public set largeMode(value: boolean) {
    this.option.largeMode = value;
  }

  public setLargeMode(value: boolean): void {
    this.largeMode = value;
  }

  public get showSaseung(): boolean {
    return this.option.showSaseung;
  }

  public set showSaseung(value: boolean) {
    this.option.showSaseung = value;
  }

  public setShowSaseung(value: boolean): void {
    this.showSaseung = value;
  }

  public get wordLevel(): STAR_FILTER {
    return this.option.wordLevel;
  }

  public set wordLevel(value: STAR_FILTER) {
    this.option.wordLevel = value;
  }

  public get seungjoDispType(): SEUNGJO_DISP_TYPE {
    return this.option.seungjoDispType;
  }

  public set seungjoDispType(value: SEUNGJO_DISP_TYPE) {
    this.option.seungjoDispType = value;
  }


  protected getSnsNaverTxt(): string {
    if (this.snsInfo?.naver) {
      return '연동 해제';
    } else {
      return '연동 하기';
    }
  }

  onBookmarkSync($event: MouseEvent) {
    if (this.snsInfo?.naver) {
      // 연동 되어있다면 연동 끊기

      this.snsSvc.DisconnectNaverLogin().subscribe(() => {
          console.log('OptionsComponent::onBookmarkSync() DisconnectNaverLogin()');
          this.snsInfo!.naver = false;
        },
        (err) => {
          console.error('OptionsComponent::onBookmarkSync() DisconnectNaverLogin()', err);
        });
    } else {
      // 연동 안 되어있다면 연동 하기
      this.snsSvc.ConnectNaverLogin().subscribe(() => {
          console.log('OptionsComponent::onBookmarkSync() ConnectNaverLogin()');
          this.snsInfo!.naver = true;

        },
        (err) => {
          console.error('OptionsComponent::onBookmarkSync() ConnectNaverLogin()', err);
        });
    }
  }
}
